import { useParams, useHistory, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import moment from "moment";

import "./HistoryIndebted.css";

// components
import AnimationLoading from "../../components/Animationloading";
import { convertCurrency, numberFormat } from "../../helper";

// apollo-client
import { GET_ORDERGROUPS } from "../../apollo/ordergroup/query";
import { useLazyQuery } from "@apollo/client";

// react-bootrap
import { Form, Col, Card } from "react-bootstrap";
import EmptyComponent from "../../components/EmptyComponent";
import BreadCrumbComponent from "../../components/BreadCrumbComponent";

export default function HistoryIndebtedDetail() {
  const history = useHistory();
  const Location = useLocation();
  const [customer, setCustomer] = useState();
  const [currentStartDate, setCurrentStartDate] = useState();
  const [currentEndDate, setCurrentEndDate] = useState();
  const [ordergroup, setOrderGroup] = useState();
  const [ordergroupTotal, setOrderGroupTotal] = useState();
  const { id } = useParams();

  // ============== > UseLazyQuery And UseMutaion <==============

  const [loadordergroup, { data: getordergroupsData, loading }] = useLazyQuery(
    GET_ORDERGROUPS,
    { fetchPolicy: "cache-and-network" }
  );

  // ============== > useEffect <==============

  useEffect(() => {
    _fetchOrderGeoup();
  }, [currentStartDate, currentEndDate]);

  useEffect(() => {
    setCustomer(Location?.state?.state);
    
  }, []);

  useEffect(() => {
    if (getordergroupsData) {
      setOrderGroup(getordergroupsData?.orderGroups?.data);
      setOrderGroupTotal(getordergroupsData?.orderGroups?.total ?? 0);
 
      
    }
  }, [JSON.stringify(getordergroupsData), Location?.state?.state]);

  // ============== > fuctions <==============

  const _fetchOrderGeoup = async () => {
    let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    let _where = {
      shop: shopId,
      customerId: id,
      status: "INDEBTED",
      isDeleted: false,
    };
    //check if filter date is set
    if (currentStartDate && currentEndDate) {
      _where = {
        ..._where,
        createdAt_gte: new Date(
          moment(moment(currentStartDate).format("YYYY-MM-DD")).toISOString()
        ),
        createdAt_lt: new Date(
          moment(moment(currentEndDate).add(1, "days")).format("YYYY-MM-DD")
        ).toISOString(),
      };
    }
    await loadordergroup({
      variables: {
        where: _where,
        // orderBy: "createdAt_DESC"
      },
    });
  };

  const handleChangeStartDate = (e) => {
    setCurrentStartDate(e?.target?.value);
  };

  const handleChangeEndDate = (e) => {
    setCurrentEndDate(e?.target?.value);
  };

  // Check if ordergroupTotal is 0 and go back in history if true

  // if (ordergroupTotal <= 0) {
  //   history.goBack();
  // }

  return (
    <React.Fragment>
      
      <div style={{ padding: "1em" }}>
        <Card style={{ border: "none", padding: "1em 1.5em" }}>
          <div>
            <h4>
              <b>ໃບຄ້າງໜີ້</b>
            </h4>
            <p>
              ເກັບປະຫວັດອໍເດີ້ທີ່ລູກຄ້າຕິດໜິ້ໄວ້ ລາຍການບິນທັງໝົດ [{" "}
              {ordergroupTotal} ] ລາຍການ.
            </p>
          </div>

          <div
            style={{
              fontSize: "16px",
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div>ຂໍ້ມູນລູກຄ້າ</div>
              <div>
                ຊື່ ເເລະ ນາມສະກຸນ : {customer?.customerName}{" "}
                {customer?.customerLastName}{" "}
              </div>
              <div>ເບີໂທ : {customer?.phone} </div>
              <div className="w-100">
                ທີ່ຢູ່ {customer?.village}, ເມືອງ : {customer?.district}, ເເຂວງ : {customer?.province}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}>
              <div className="row">
                <Col className="col-6"></Col>
                <Col className="col-3">
                  <Form.Label>ຕັ້ງເເຕ່ວັນທີ</Form.Label>
                  <Form.Control
                    type="date"
                    value={currentStartDate}
                    onChange={(e) => handleChangeStartDate(e)}
                  />
                </Col>
                <Col className="col-3">
                  <Form.Label>ຫາວັນທີ</Form.Label>
                  <Form.Control
                    type="date"
                    value={currentEndDate}
                    onChange={(e) => handleChangeEndDate(e)}
                  />
                </Col>
              </div>
            </div>
          </div>

          {loading && !getordergroupsData ? (
            <AnimationLoading />
          ) : (
            <>
              {ordergroup?.length > 0 ? (
                <div className="card-bill-all">
                  {ordergroup?.map((order, index) => (
                    <div
                      className="billShow"
                      onClick={() =>
                        history.push("/promissory_note", { state: order })
                      }>
                      <h5>ບິນທີ {index + 1}</h5>

                      <div className="billResult">
                        <div className="txtBill">
                          <p>ວັນທີສ້າງບິນ</p>
                          <p>
                            {moment(order?.createdAt).format(
                              "DD/MM/YYYY HH:mm:ss"
                            )}
                          </p>
                        </div>
                        <div className="txtBill">
                          <p>ວັນທີຈ່າຍເງິນ</p>
                          <p>
                            {moment(order?.paymentDate).format(
                              "DD/MM/YYYY"
                            )}
                          </p>
                        </div>
                        <div className="txtBill">
                          <p>ເລກທີບິນ</p>
                          <p> {order?.code}</p>
                        </div>
                        <div className="txtBill">
                          <p>ຈຳນວນ </p>
                          <p> {order?.amount}</p>
                        </div>
                        {/* //CASH */}
                        {order?.cash > 0 && (
                        <div className="txtBill">
                          <p>ເງີນສົດ</p>
                          <p>
                            {numberFormat(order?.cash)}{" "}
                            {convertCurrency(order?.currency) ?? ""}
                          </p>
                        </div>
                        )}
                        {/* //TRANSFER */}
                        {order?.transfer > 0 && (
                        <div className="txtBill">
                          <p>ເງີນສົດ</p>
                          <p>
                            {numberFormat(order?.transfer)}{" "}
                            {convertCurrency(order?.currency) ?? ""}
                          </p>
                        </div>
                        )}
                        {/* //DEBT */}
                        {order?.debt > 0 && (
                        <div className="txtBill">
                          <p>ເງີນຕີດຫນີ້</p>
                          <p>
                            {numberFormat(order?.debt)}{" "}
                            {convertCurrency(order?.currency) ?? ""}
                          </p>
                        </div>
                        )}
                        <div className="txtBill">
                          <p>ເງິນລວມທັງໝົດ</p>
                          <p>
                            {numberFormat(order?.sumPrice)}{" "}
                            {convertCurrency(order?.currency) ?? ""}
                          </p>
                        </div>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            fontSize: "23px",
                            fontWeight: "600",
                            paddingTop: "1em",
                          }}>
                          ສະຖານະ :{" "}
                          {order?.status === "INDEBTED" ? "ຕິດໜິ້" : ""}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <EmptyComponent />
              )}
            </>
          )}
        </Card>
      </div>
    </React.Fragment>
  );
}
